import { Box, Grid, Paper, TableContainer, Typography } from '@mui/material';
import BuybackTable from './buybackTable';

const BuybackTransactions = ({ trigger }) => {
  return (
    <Grid
      pt={'50px !important'}
      container
      item
      xs={12}
      spacing={{ xs: 2, sm: 2, md: 3 }}
    >
      <Grid mt={{ xs: '20px', md: '40px' }} pt={'0px !important'} item xs={12}>
        <Box
        // sx={{
        //   background: 'rgba(255, 255, 255, 0.2)',
        //   borderRadius: { xs: '12px', sm: '14px', md: '16px' },
        //   boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        //   border: '1px solid rgba(255, 255, 255, 0.3)',
        //   backdropFilter: 'blur(8px) saturate(180%)',
        //   p: { xs: 2, sm: 2.5, md: 3 },
        //   transition: 'box-shadow 0.3s ease',
        //   '&:hover': {
        //     boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
        //   },
        // }}
        >
          <Typography
            variant={{ xs: 'h6', sm: 'h6', md: 'h5' }}
            sx={{
              fontWeight: 700,
              color: '#111827',
              mb: { xs: 2, sm: 2, md: 3 },
              letterSpacing: '0.5px',
              textAlign: { xs: 'left', sm: 'center', md: 'center' },
            }}
          >
            تراکنش‌های بازخرید
          </Typography>
          <TableContainer
            component={Paper}
            sx={{
              mt: 2,
              borderRadius: '12px',
              border: 'none',
              boxShadow: 'none',
              background: 'transparent',
              overflowX: { xs: 'auto', sm: 'auto', md: 'visible' },
              WebkitOverflowScrolling: 'touch',
              minWidth: 'auto',
            }}
          >
            <BuybackTable
              trigger={trigger}
              // setTotalTodaysSell={buybacks?.data}
              // Pass additional props if DataTable supports them
              sx={{
                '& .MuiTableHead-root': {
                  background: 'linear-gradient(45deg, #2563eb, #1d4ed8)',
                  borderRadius: '12px 12px 0 0',
                  '& th': {
                    fontWeight: 700,
                    color: '#fff',
                    py: { xs: 1.5, sm: 1.5, md: 2 },
                    px: { xs: 1, sm: 1.5, md: 2 },
                    fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.85rem' },
                    borderBottom: 'none',
                    whiteSpace: 'nowrap',
                  },
                },
                '& .MuiTableBody-root': {
                  '& tr': {
                    background: theme =>
                      theme.palette.mode === 'light'
                        ? 'rgba(255, 255, 255, 0.9)'
                        : 'rgba(243, 244, 246, 0.9)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: 'rgba(191, 219, 254, 0.7)',
                      boxShadow: '0 4px 16px rgba(59, 130, 246, 0.2)',
                    },
                    '& td': {
                      color: '#111827',
                      borderBottom: 'none',
                      fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.85rem' },
                      py: { xs: 1, sm: 1.2, md: 1.5 },
                      px: { xs: 1, sm: 1.5, md: 2 },
                      fontWeight: 500,
                      whiteSpace: { xs: 'nowrap', sm: 'nowrap', md: 'normal' },
                    },
                  },
                },
              }}
            />
          </TableContainer>
        </Box>
      </Grid>
    </Grid>
  );
};

export default BuybackTransactions;
